import React from 'react';
import { Columns } from '@components/Columns';
import { Box } from '@components/Box';

import {
  PersonalTravelConciergeSectionWrapper,
  HeroTextContainer,
  StyledHeroTextColumn,
  StyledTextPairing,
  StyledGetStartedButton,
} from './PersonalTravelConciergeSection.styles';
import { InfiniteSlider } from '@components/InfiniteSlider';
import { useTranslation } from 'react-i18next';

export const PersonalTravelConciergeSection = () => {
  const { t } = useTranslation('hotelRoomBlocks');
  const personalTravelConciergeSectionData = t('personalTravelConciergeSection');
  return (
    <PersonalTravelConciergeSectionWrapper id="UniversalRegistry">
      <Box paddingTop={[0, 0]}>
        <Box>
          <HeroTextContainer marginTop={[0, 0]}>
            <StyledHeroTextColumn centered>
              <Columns.Column width={12}>
                <StyledTextPairing
                  eyebrow={personalTravelConciergeSectionData.title}
                  eyebrowColor="humanaDark4"
                  eyebrowVariant="sectionEyeBrow20"
                  eyebrowTagName="h2"
                  title={personalTravelConciergeSectionData.subtitle}
                  titleVariant="hed56"
                  titleColor="humanaDark6"
                  titleTagName="h2"
                  body={personalTravelConciergeSectionData.description}
                  bodyVariant="dek20"
                  bodyColor="neutra5"
                  alignment={'center'}
                >
                  <StyledGetStartedButton id="menu2create" variant={'primary'} page={'hotel-room-blocks'}>
                    {personalTravelConciergeSectionData.buttonStarted}
                  </StyledGetStartedButton>
                </StyledTextPairing>
              </Columns.Column>
            </StyledHeroTextColumn>
          </HeroTextContainer>
        </Box>
      </Box>
      <Box marginTop={12} paddingTop={[0, 3]}>
        <InfiniteSlider
          scrollName="baby-registry-brands"
          images={[...personalTravelConciergeSectionData.images]}
          speed={6}
          gap={{ sm: 50, belowSm: 30 }}
        />
      </Box>
    </PersonalTravelConciergeSectionWrapper>
  );
};
